export default {
  nav: {
    create: { name: "定制游戏" },
    menu: [
      // {
      //   name: "最新消息",
      //   to: {
      //     name: "blog",
      //     params: {
      //       link: "https://multiverse-news.blogspot.com/",
      //       height: "1699px",
      //     }
      //   }
      // },
      {
        name: "关于我们",
        to: {
          name: "about",
          params: {}
        }
      },
      // {
      //   name: "加入我们",
      //   to: {
      //     name: "careers",
      //     params: {}
      //   }
      // },
      // { name: "联系我们", link: '/contact' },
    ]
  },
  home: {
    games: "游戏",
    games_all: "所有游戏",
    awards: "所获荣誉",
    news: "重要消息",
    news_all: "所有消息",
    join_us: "加入我们",
    join_us_des: "了解与我们一起工作的机会",
    join_us_des2: "一起创造世界吧！",
    join_us_des3: "我们一直在招聘。\n如果你是一名开发者，\n请联系我们！",
    join_us_btn: "联系我们",
    more: "了解更多",
    explore: "探索",
  },
  games: [
    { id: 'sd', name: '寻找黎明', link: 'https://www.seekingdawn.com', des: '《寻找黎明(Seeking Dawn)》是一款科幻生存元素的VR游戏，由国内团队Multiverse耗时两年研发，玩家将在游戏中化身为星际战士，偶遇各种奇形怪状的外星动植物，消灭虎视眈眈的敌对势力，追寻失联的盟军的踪迹等。科幻写实的美术风格使得这个世界绚丽而又危险。《寻找黎明(Seeking Dawn)》曾荣获2017腾讯GAD-VR游戏开发者大赛最佳视觉奖、2018 VRCORE Awards最佳美术奖、2018金陀螺年度最佳VR游戏奖。' },
    { id: 'efas', name: '异宇星还', link: 'http://www.earthfromanothersun.com', des: '《异宇星还(Earth From Another Sun)》是Multiverse全新开发的一款带有Rogue-like元素的科幻FPS PC游戏，未来的地球因为某种神秘力量，通过虫洞穿越到了现在，当未来不再是未来，当时间不再有意义，当地球降临之日，玩家可以亲身去探索这个世界会变成什么样。《异宇星还》 受邀出席Unite Copenhagen 2019，并作为演讲案例的国产PC游戏，目前已更名为《幸福勇者》，在腾讯WeGame测试区开启Pre-Alpha限号测试，预计于2020年第二季度开启Early Access。' },
    { id: 'low', name: '追随者联萌', link: 'http://low.multiverseinc.com', des: '《追随者联萌(League of Wannabes)》是一款带沙盒元素的实时动作冒险类Roguelike游戏。游戏将爽快刺激的实时动作元素，变幻莫测的Roguelike随机元素和超高自由度的沙盒关卡相结合。可破坏可燃烧的场景，拥有自己生活的NPC，动态变化的世界涌现出丰富的策略玩法。《追随者联萌》荣获2019indiePlay最佳设计提名，2019Indie Prize最佳移动游戏提名和最佳游戏设计提名，2019金茶奖最佳原创游戏。游戏预计2020年第二季度开启公测。' },
    { id: 'df', name: '梦幻风之旅', link: 'https://www.oculus.com/experiences/gear-vr/1013248532088752', des: '驾驶纸飞机的小姑娘，穿越充满魔力的梦幻世界，寻找失散的同伴，《梦幻风之旅(Reveries: Dream Flight)》是一款音乐飞行游戏，在全球拥有超过20万次的下载量，在全球移动VR用户中的渗透率达到了5%，游戏还帮助斯坦福大学儿童医院的病人减轻压力和疼痛。《梦幻风之旅(Reveries: Dream Flight)》还曾获得海外媒体的盛赞“This is the type of game VR was made for.”“The great soundtrack and beautiful visuals make this a must have for those looking for a little serenity in their VR gaming.”' },
    { id: 'sdlbe', name: '寻找黎明：异星', link: 'https://www.seekingdawn.com', des: '《寻找黎明(Seeking Dawn)》是一款科幻生存元素的VR游戏，由国内团队Multiverse耗时两年研发，玩家将在游戏中化身为星际战士，偶遇各种奇形怪状的外星动植物，消灭虎视眈眈的敌对势力，追寻失联的盟军的踪迹等。科幻写实的美术风格使得这个世界绚丽而又危险。《寻找黎明(Seeking Dawn)》曾荣获2017腾讯GAD-VR游戏开发者大赛最佳视觉奖、2018 VRCORE Awards最佳美术奖、2018金陀螺年度最佳VR游戏奖。' },
  ],
  contact: {
    title: "和我们聊聊",
    sub_title: "现在就和我们聊一聊，不管你是不是正在找工作。",
    list: [
      {
        title: "公司名称：",
        text: "深圳市摩登世纪科技有限公司"
      },
      {
        title: "沟通交流：",
        text: "contact@multiverseinc.com",
      },
      {
        title: "公共关系：",
        text: "pr@multiverseinc.com",
      },
      {
        title: "英才招聘：",
        text: "careers@multiverseinc.com",
      },
      {
        title: "商务合作：",
        text: "freeman@multiverseinc.com",
      },
      {
        title: "公司地址：",
        text: "深圳市南山区南山大道南园枫叶大厦10L",
      },
    ]
  },
  news: [
    { title: "利用Intel Graphics Performance Analyzers (Intel GPA) 优化Earth From Another Sun图形性能", type: "Earth From Another Sun", cover: "/images/news-3.png", link: "https://blogger.multiverseinc.com/2020/06/intel-graphics-performance-analyzers.html", created_at: "MAY 2ND, 2017", height: "9200px" },
    { title: "Working under the coronavirus quarantine", type: "Multiverse", cover: "/images/news-0.png", link: "https://multiverse-news.blogspot.com/2020/03/working-under-coronavirus-quarantine_6.html", created_at: "MAY 2ND, 2017", height: "2600px" },
    { title: "Earth From Another Sun at Unite Copenhagen 2019", type: "Earth From Another Sun", cover: "/images/news-1.png", link: "https://multiverse-news.blogspot.com/2019/09/earth-from-another-sun-at-unite.html", created_at: "Jun 19, 2017", height: "4000px" },
    // { title: "Seeking Dawn Valve Index Integration Update!", type: "Seeking Dawn", cover: "/images/news-2.png", link: "https://multiverse-news.blogspot.com/2019/11/seeking-dawn-valve-index-integration.html", created_at: "MAY 2ND, 2017", height: "1600px" },
  ],
  about: {
    title: "我们是一群\n不怕被猫踢歪的人",
    story: {
      title: "我们的故事",
      text: `        2016年，为了一个共同的梦想，我们成立了Multiverse（猫踢歪游戏）。这个梦想，就是有朝一日成为一家让全球玩家耳熟能详的游戏研发公司，就像今天的暴雪、Bungie或者顽皮狗。
        我们是一群追求创意与极高的游戏性相结合的资深游戏开发者。我们既有来自斯坦福大学及国际一线游戏公司的极客，也有没上过学，自学成才的草根游戏人。我们还有连续获奖的独立游戏开发者、钢琴家、作家、美术讲师、教科书作家、黑客、摇滚歌手、演讲高手、PPT大师及全国电竞冠军。
        我们正在研发数款令人无比激动的新产品，包括《异宇星还》（PC、PlayStation、Xbox），《追随者联萌》及《梦幻风之旅》（移动），《寻找黎明：异星》（VR大空间），《王国角斗士》（AR）。
        团队之前的产品《寻找黎明》是全球规模及销量最大的VR游戏之一，获得的奖项摆满了一面墙。《梦幻风之旅》是目前全球评分最高的国产VR游戏。团队开发的休闲手机游戏也获得了超过3000万的全球下载量。
        我们曾做出了畅销全球的独立游戏，也有千万美元级别的风险投资加持。更重要的是，我们拥有无比优秀的团队，为连续产出爆款打好了基础。`,
    },
    values: {
      title: "我们的价值观",
      list: [
        {
          title: "无私",
          des: "把团队的目标当做自己最重要的事\n永远放在个人利益之前",
        },
        {
          title: "不倦",
          des: "孜孜不倦\n为完成团队的目标勇往直前\n劳逸结合\n高效工作",
        },
        {
          title: "无畏",
          des: "无所畏惧\n不会被新的问题难倒\n而总能想到解决问题的办法",
        },
        {
          title: "可靠",
          des: "不用多说\n就是靠谱",
        },
        {
          title: "好奇",
          des: "对世界充满好奇心\n总是在学习新的东西\n开阔自己的眼界和技能广度",
        },
      ]
    }
  },
}
